// extracted by mini-css-extract-plugin
export default {"filter-footer":"style_filter-footer__44DDs","filterFooter":"style_filter-footer__44DDs"};